import all from './all';
import packaging from './packaging';
import basic from './basic';

export default {
  all,
  packaging,
  basic,
};



// WEBPACK FOOTER //
// ./src/app/services/exciseGroup/index.js